import { render, staticRenderFns } from "./Ilmoitus.vue?vue&type=template&id=9534c164&scoped=true"
import script from "./Ilmoitus.vue?vue&type=script&lang=js"
export * from "./Ilmoitus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534c164",
  null
  
)

export default component.exports